export function theme_accessibility() {

	document.addEventListener( 'keydown', function( event ) {

		let elements 	= document.querySelectorAll( 'input, a, button' );
		elements = Array.prototype.slice.call( elements );

		const tabKey 	= event.keyCode === 9;
		const shiftKey 	= event.shiftKey;
		const activeEl 	= document.activeElement;

		const lastEl 	= elements[ elements.length - 1 ];
		const firstEl 	= elements[0];

		if ( ! shiftKey && tabKey && lastEl === activeEl ) {
			event.preventDefault();
			firstEl.focus();
		}

		if ( shiftKey && tabKey && firstEl === activeEl ) {
			event.preventDefault();
			lastEl.focus();
		}

		// If there are no elements in the menu, don't move the focus
		if ( tabKey && firstEl === lastEl ) {
			event.preventDefault();
		}

	});

}
